/* Project Import will be here */
import { authTokenKey } from "services/index";
import { IProfileParams } from "models/profileModels";
/* Project Import will be here */

/* Phone number */
type ILoginId = string | number;
type IPassword = string | number;

export type IRequestLoginOtpParams = {
  data: {
    loginId: ILoginId
  },
  headers: {
    [authTokenKey]: string
  }
};

export type ILoginParams = {
  loginId: ILoginId,
  password: IPassword
};

export type IJnJLoginParams = {
  loginId: ILoginId,
  mobileNo: string | number,
  query: any
};

export type INewLoginParams = {
  loginId: ILoginId,
  query: any
};

export type INewLoginPasswordParams = {
  loginId: ILoginId,
  password: string
};

export type INewLoginChangePasswordParams = {
  NewPassword: string,
  ConfirmPassword: string
};

export type INewUserParams = {
  loginId: ILoginId
};

export type IRequestChangeMobNoParams = {
  data: {
    oldmobileno: ILoginId,
    mobileno: number
  }
};
export type IRequestMobChangeParams = {
  data: {
    mobileno: ILoginId
  },
  headers: {
    [authTokenKey]: string
  }
};

export type IChangeMobileNoParams = {
  data: {
    mobileno: ILoginId,
    otp: string | number
  }
};

export type IUpdateMobileNoParams = {
  data: {
    mobileno: ILoginId,
    otp: string | number
  },
  headers: {
    [authTokenKey]: string
  }
};

export type IVerifyOtpParams = {
  data: {
    otp: string | number
  },
  headers: {
    [authTokenKey]: string
  }
};

export type ISignUpWithProfileParams = {
  data: {
    FirstName: string,
    LastName: string,
    RetailerName: string,
    Address: string,
    CityId: number,
    StateId: number,
    Region: number,
    CountryId: number,
    ChId: number,
    SchId: number,
    TinNo: string,
    Latitude?: string | number,
    Longitude?: string | number,
    Pincode: string | number,
    Password: string | number,
    PrincipalIds: number[]
  },
  headers: {
    [authTokenKey]: string
  }
};

export type IForgotPassParams = {
  loginId: ILoginId
};

export type IResetPasswordParams = {
  data: {
    password: IPassword
  },
  headers: {
    [authTokenKey]: string
  }
};

export type IChangePasswordParams = {
  data: {
    password: IPassword,
    newPassword: IPassword
  },
  headers: {
    [authTokenKey]: string
  }
};

export type IChangePassActionParams = {
  Password: string | number,
  NewPassword: string | number,
};

export type IChangePasswordRequest = {
  Password: string,
  NewPassword: string,
  confirmNewPassword: string
};

export type IVerifyOtpActionParams = {
  otp: string | number
};

export type ISignUpActionParams = {
  ...ILoginParams,
  ...IProfileParams
};

export type ISignUpWithProfile = {
  signup: ILoginParams,
  profile: IProfileParams
};

export type IResetPassActionParams = {
  password: string | number
};